<template>
    <div class="about-content">
        <home-nav></home-nav>
        <div class="home-carousel" id="home-carousel" ref="currentWidth">
            <el-carousel
                    :width="carouselWidth + 'px'"
                    height="510px"
                    :autoplay="false"
                    arrow="hover"
            >
                <el-carousel-item v-for="(item,index) in carouselList" :key="index">
                    <img :src="item.imgUrl" alt="">
                </el-carousel-item>
            </el-carousel>

            <div class="carousel-detail">
                <p class="detail-bold">
                    包车行业的开拓者
                </p>
                <p class="detail-normal">
                    为您节省70%的出行时间 减少您90%的搭乘苦恼 提升您100%的旅途愉悦
                </p>
            </div>
        </div>

        <div class="about-listing" id="about-listing">
            <div class="about-listing-box">
                <div class="about-listing-area"
                     v-for="(item, index) in aboutListing"
                     :key="index"
                     @mouseenter="liMouseEnter(index)"
                     @mouseleave="liMouseLeaver()"
                >
                    <div class="area-top">
                        <img :src="item.icon" alt="">
                    </div>
                    <div class="area-btn-text">
                        <span class="area-btn-spanone">{{ item.text }}</span>
                        <span class="area-btn-spantwo">{{ item.btnText }}</span>
                    </div>

                    <transition name="fade">
                        <div class="about-listing-back" v-show="curHover == index">
                            <p class="about-listing-back-title">
                                {{ item.text }}
                            </p>
                            <p class="about-listing-back-detail">
                                {{ item.detailText }}
                            </p>
                        </div>
                    </transition>
                </div>
            </div>
        </div>

        <div class="about-elegant to0" id="about-elegant">
            <ul :class="scrllerFixed ? 'about-elegant-ul' : 'about-elegant-ul-fixed'">
                <li class="about-elegant-li"
                    :class="currentClick == index ? 'about-elegant-li-ac' : ''"
                    v-for="(item, index) in elegantList"
                    :key="index"
                    @click="elegantListClick(index)"
                >
                    {{ item.text }}
                </li>
            </ul>

            <div class="about-elegant-list">
                <div class="about-elegant-right"
                     v-for="(item,index) in elegantDetailList"
                     :key="index"
                >
                    <div class="about-elegant-right-img">
                        <img :src="item.img" alt="">
                    </div>
                    <div class="about-elegant-right-detail">
                        <p class="about-elegant-right-title">
                            {{ item.title }}
                        </p>
                        <div class="about-elegant-right-line"></div>
                        <p class="about-elegant-right-content">
                            {{ item.content }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!--公司风采-->
        <div class="about-elegant-detail to1" id="about-elegant-detail">
            <p class="about-elegant-detail-title">
                公司风采
            </p>
            <p class="about-elegant-detail-introduction">
                保时达互联网配驾包车平台，成立以来累计服务4100万包车用户
            </p>
            <div class="about-elegant-detail-imgs">
                <img src="@/assets/images/about/aboutUs_img02.png" alt="">
            </div>
        </div>

        <!--企业理念-->
        <div class="about-idea to2" id="about-idea">
            <div class="about-idea-content">
                <p class="about-elegant-detail-title">
                    企业理念
                </p>
                <p class="about-elegant-detail-introduction">
                    使命，责任，追求，我们秉承谦卑之心，以客户为上帝
                </p>
                <ul class="about-idea-list">
                    <li class="about-idea-li" v-for="(item,index) in ideaList" :key="index">
                        <div class="about-idea-li-left">
                           <span class="about-idea-li-bold">
                               {{ item.boldText }}
                           </span>
                            <span class="about-idea-li-normal">
                               {{ item.normalOne }}
                           </span>
                            <span class="about-idea-li-normal">
                               {{ item.normalTwo }}
                           </span>
                        </div>
                        <div class="about-idea-img">
                            <img :src="item.imgUrl" alt="">
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <!--关于保时达-->
        <div class="concerning" id="concerning">
            <div class="concerning-box">
                <p class="about-elegant-detail-title">
                    关于保时达
                </p>
                <p class="about-elegant-detail-introduction">
                    保时达互联网配驾包车平台，您包车的最佳选择
                </p>
                <div class="concerning-list" ref="numCount">
                    <div class="concerning-list-detail">
                        <div class="concerning-list-top">
                            <span class="concerning-list-num">
                                <number-grow :value="8560"></number-grow>
                            </span>
                            <span class="concerning-list-text">万</span>
                        </div>
                        <div class="concerning-list-bot">
                            服务客户
                        </div>
                    </div>

                    <div class="concerning-list-detail">
                        <div class="concerning-list-top">
                            <span class="concerning-list-num">
                                <number-grow :value="52"></number-grow>
                            </span>
                            <span class="concerning-list-text">万</span>
                        </div>
                        <div class="concerning-list-bot">
                            入驻车队
                        </div>
                    </div>

                    <div class="concerning-list-detail">
                        <div class="concerning-list-top">
                            <span class="concerning-list-num">
                                <number-grow :value="264"></number-grow>
                            </span>
                            <span class="concerning-list-text">座</span>
                        </div>
                        <div class="concerning-list-bot">
                            覆盖城市
                        </div>
                    </div>
                </div>

                <div class="concerning-imgs">
                    <img src="@/assets/images/about/aboutUs_img03.png" alt="">
                </div>
            </div>
        </div>

        <!--保时达大事件-->
        <div class="about-big-event to3" id="about-big-event">
            <img class="about-big-back" src="@/assets/images/about/aboutUs_img_bg.png" alt="">

            <p class="about-elegant-detail-title">
                保时达大事件
            </p>

            <div class="about-big-event-list" v-if="eventList.length">
                <div class="about-big-event-area"
                     :class="currentList == index ?  '' : (eventList.length != 0 ? 'about-big-event-area-ac' : '')"
                     v-for="(item,index) in eventList"
                     :key="index"
                >
                    <div class="about-big-event-time">
                        {{ item.timedate }}
                    </div>
                    <div class="about-big-event-con">
                        <p class="about-big-event-title">
                            {{ item.title }}
                        </p>
                        <p class="about-big-event-text">
                            {{ item.content }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!--底部-->
        <home-footer></home-footer>

        <left-code></left-code>
        <right-list></right-list>
    </div>
</template>

<script>
    import homeNav from '@/components/homeNav';
    import homeFooter from '@/components/homeFooter';

    import LeftCode from '@/components/leftCode';
    import RightList from "@/components/rightList";
    import numberGrow from "@/components/numberGrow";

    export default {
        name: "about",
        components: {
            homeNav,
            homeFooter,
            LeftCode,
            RightList,
            numberGrow
        },
        data() {
            return {
                carouselWidth: '',
                carouselList: [
                    {
                        imgUrl: require('@/assets/images/about/aboutUs_banner01.png'),
                    }
                ],

                curHover: -1,
                aboutListing: [
                    {
                        icon: require('@/assets/images/about/aboutUs_icon_yq01.png'),
                        text: '企业精神',
                        btnText: '以人为本，追求卓越',
                        detailText: '以人为本，追求卓越，在我们擅长的陪驾包车领域给客户提供增值服务',
                    },
                    {
                        icon: require('@/assets/images/about/aboutUs_icon_yq02.png'),
                        text: '企业目标',
                        btnText: '超前理念，创新思维',
                        detailText: '用超前的经营理念，创新的思维进行资源整合，做包车行业的领头羊',
                    },
                    {
                        icon: require('@/assets/images/about/aboutUs_icon_yq03.png'),
                        text: '企业价值',
                        btnText: '成功，创造价值，安全',
                        detailText: '企业不仅追求经济效益，更追求员工的事业成功和社会效益、安全',
                    },
                    {
                        icon: require('@/assets/images/about/aboutUs_icon_yq04.png'),
                        text: '企业性格',
                        btnText: '共同发展，诚实守信',
                        detailText: '共同发展是我们的原则，诚实守信是我们的性格，令每个用户满意说我们的目标',
                    }
                ],
                scrllerFixed: true,

                elegantList: [
                    {
                        text: '公司简介',
                    },
                    {
                        text: '公司风采',
                    },
                    {
                        text: '企业理念',
                    },
                    {
                        text: '公司事件',
                    },
                ],
                listBoxState: true,//点击导航栏时，暂时停止监听页面滚动
                listBox: [0, 1, 2, 3],

                currentClick: 0,
                elegantDetailList: [
                    {
                        img: require('@/assets/images/about/aboutUs_img01.png'),
                        title: '以市场为导向，以服务求发展打造行业新典范',
                        content: '皇包车（厦门）科技集团有限公司福州分公司专注于汽车租赁事业。自公司成立以来，逐步形成了商务用车、公务用车、会议用车、机场接送、婚庆用车、旅游用车等全天候用车服务。并与多家大型事业单位、外商独资企业、高科技民营企业建立了长期稳定的合作关系。同时还提供面对个人用户的多种用车服务。我司拥有一支高素质、高学历和经验丰富的管理队伍，配合驾驶技能娴熟、路况经验丰富的专业司机队伍形成了一个面对激烈市场竞争，敢于创新、全面细致、专业诚信的优秀团队，博得了众多客户的青睐和信任\n',
                    },
                    /*{
                        img: require('@/assets/images/about/aboutUs_img01.png'),
                        title: '02以市场为导向，以服务求发展打造行业新典范',
                        content: '皇包车（厦门）科技集团有限公司福州分公司专注于汽车租赁事业。自公司成立以来，逐步形成了商务用车、公务用车、会议用车、机场接送、婚庆用车、旅游用车等全天候用车服务。并与多家大型事业单位、外商独资企业、高科技民营企业建立了长期稳定的合作关系。同时还提供面对个人用户的多种用车服务。我司拥有一支高素质、高学历和经验丰富的管理队伍，配合驾驶技能娴熟、路况经验丰富的专业司机队伍形成了一个面对激烈市场竞争，敢于创新、全面细致、专业诚信的优秀团队，博得了众多客户的青睐和信任\n',
                    },
                    {
                        img: require('@/assets/images/about/aboutUs_img01.png'),
                        title: '03以市场为导向，以服务求发展打造行业新典范',
                        content: '皇包车（厦门）科技集团有限公司福州分公司专注于汽车租赁事业。自公司成立以来，逐步形成了商务用车、公务用车、会议用车、机场接送、婚庆用车、旅游用车等全天候用车服务。并与多家大型事业单位、外商独资企业、高科技民营企业建立了长期稳定的合作关系。同时还提供面对个人用户的多种用车服务。我司拥有一支高素质、高学历和经验丰富的管理队伍，配合驾驶技能娴熟、路况经验丰富的专业司机队伍形成了一个面对激烈市场竞争，敢于创新、全面细致、专业诚信的优秀团队，博得了众多客户的青睐和信任\n',
                    },
                    {
                        img: require('@/assets/images/about/aboutUs_img01.png'),
                        title: '04以市场为导向，以服务求发展打造行业新典范',
                        content: '皇包车（厦门）科技集团有限公司福州分公司专注于汽车租赁事业。自公司成立以来，逐步形成了商务用车、公务用车、会议用车、机场接送、婚庆用车、旅游用车等全天候用车服务。并与多家大型事业单位、外商独资企业、高科技民营企业建立了长期稳定的合作关系。同时还提供面对个人用户的多种用车服务。我司拥有一支高素质、高学历和经验丰富的管理队伍，配合驾驶技能娴熟、路况经验丰富的专业司机队伍形成了一个面对激烈市场竞争，敢于创新、全面细致、专业诚信的优秀团队，博得了众多客户的青睐和信任\n',
                    },*/
                ],

                ideaList: [
                    {
                        boldText: '快速稳定',
                        normalOne: '24小时待命',
                        normalTwo: '打造一站式互联网包车服务',
                        imgUrl: require('@/assets/images/about/aboutUs_img_car01.png')
                    },
                    {
                        boldText: '极致响应',
                        normalOne: '机制创新的思维',
                        normalTwo: '产品、服务、将客户放在首位',
                        imgUrl: require('@/assets/images/about/aboutUs_img_car02.png')
                    },
                    {
                        boldText: '谦卑为怀',
                        normalOne: '认真做好每一个细节',
                        normalTwo: '对待每个客户每件事秉承谦卑之心',
                        imgUrl: require('@/assets/images/about/aboutUs_img_car03.png')
                    },
                ],

                currentList: '',
                eventList: []
            }
        },
        methods: {
            elegantListClick(idx) {
                this.$el.querySelector(`.to${idx}`).scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                    block: "start"  // 上边框与视窗顶部平齐。默认值
                });
                this.listBoxState = false;

                let timeId;
                clearTimeout(timeId);
                timeId = setTimeout(() => {
                    this.currentClick = idx;
                    this.listBoxState = true;
                }, 200);
            },
            liMouseEnter(idx) {
                this.curHover = idx;
            },
            liMouseLeaver() {
                this.curHover = -1;
            },
            getInfomationDetail() {
                var that = this;

                that.$axios.get("/companyEvent").then((res) => {
                    // console.log(res);
                    res = res.data;
                    if (res.status == 200) {
                        this.eventList = res.data;
                    } else {
                        // layer.msg(res.message, {icon: 2});
                        this.$message.error(res.message);
                    }//请求成功返回的数据
                }).catch((error) => {
                    // layer.msg('系统错误', {
                    //     icon: 2
                    // });
                    this.$message.error('系统错误');
                });
            },
            //监听滚动
            getScroll() {
                // 获取视窗高度
                var domHight = document.body.offsetHeight;
                // dom滚动位置
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                var homeCarouselHeight = document.getElementById('home-carousel').scrollHeight;
                var aboutListingHeight = document.getElementById('about-listing').scrollHeight;
                var aboutElegantHeight = document.getElementById('about-elegant').scrollHeight;
                var aboutElegantDetailHeight = document.getElementById('about-elegant-detail').scrollHeight;
                var aboutIdeaHeight = document.getElementById('about-idea').scrollHeight;
                var concerningHeight = document.getElementById('concerning').scrollHeight;
                var aboutBigEventHeight = document.getElementById('about-big-event').scrollHeight;

                var concerningEventHeight = document.getElementsByClassName('concerning-list')[0].scrollHeight;


                var currentHeight = document.documentElement.clientHeight;
                var currentTop = document.getElementsByClassName('concerning-list')[0].offsetTop;

                // console.log(scrollTop);
                // console.log(homeCarouselHeight,aboutListingHeight,aboutElegantHeight,aboutElegantDetailHeight,aboutIdeaHeight,concerningHeight,aboutBigEventHeight)
                if (scrollTop > 30 + 84 + homeCarouselHeight + aboutListingHeight + 80 + 176) {
                    this.scrllerFixed = false;
                } else {
                    this.scrllerFixed = true;
                }

                if (scrollTop > 30 + 84 + homeCarouselHeight + aboutListingHeight + 80 + 176-6 && scrollTop < 30 + 84 + homeCarouselHeight + aboutListingHeight + aboutElegantHeight) {
                    this.currentClick = 0;
                } else if (scrollTop > 30 + 84 + homeCarouselHeight + aboutListingHeight + aboutElegantHeight -6 && scrollTop < 30 + 84 + homeCarouselHeight + aboutListingHeight + aboutElegantHeight + aboutElegantDetailHeight) {
                    this.currentClick = 1;
                } else if (scrollTop > 30 + 84 + homeCarouselHeight + aboutListingHeight + aboutElegantHeight + aboutElegantDetailHeight -6 && scrollTop < 30 + 84 + homeCarouselHeight + aboutListingHeight + aboutElegantHeight + aboutElegantDetailHeight + aboutIdeaHeight) {
                    this.currentClick = 2;
                } else if (scrollTop > 30 + 84 + homeCarouselHeight + aboutListingHeight + aboutElegantHeight + aboutElegantDetailHeight + aboutIdeaHeight + concerningHeight -6 && scrollTop < 30 + 84 + homeCarouselHeight + aboutListingHeight + aboutElegantHeight + aboutElegantDetailHeight + aboutIdeaHeight + concerningHeight + aboutBigEventHeight) {
                    this.currentClick = 3;
                }
            },
        },
        mounted() {
            this.currentList = this.eventList.length - 1;
            this.getInfomationDetail();
            window.scrollTo(0, 0);
            window.addEventListener('scroll', this.getScroll);
        },
        destroyed() {
            window.removeEventListener('scroll', this.getScroll);
        },
    }
</script>

<style scoped>
    @import './about.css';
</style>



// WEBPACK FOOTER //
// src/pages/about/about.vue